<template>
  <div class="animated fadeIn">
    <b-card-text class="text-left">
      <p>
        Alright, what email address would you like to use as your login?
      </p>
    </b-card-text>

    <b-form @submit="nextButtonClick">
      <b-form-group>

        <b-form-input type="text" placeholder="Account Email Address" ref="emailAddress" v-model="accountEmail" v-on:blur="accountEmailBlurred = true"></b-form-input>

        <b-form-input type="text" placeholder="Team ID" ref="teamId" v-model="accountTeamId" v-on:blur="accountTeamIdBlurred = true"></b-form-input>
      </b-form-group>

      <template v-if="dashboardEmailDataLoaded && dashboardEmailData.status != 200">
        <b-alert variant="danger" show>{{ dashboardEmailData.data.message }}</b-alert>
      </template>

      <b-button class="float-right" type="submit" variant="primary">Next</b-button>
    </b-form>
  </div>
</template>


<script>
export default {
  name: 'AdminAddUser',

  data: function() {
    return {
      accountEmail: '',
      accountEmailBlurred: false,

      accountTeamId: null,
      accountTeamIdBlurred: false,

    }
  },

  computed: {
    dashboardEmailDataLoaded() {
      return this.$store.state.dashboardEmailDataLoaded
    },
    dashboardEmailData() {
      return this.$store.state.dashboardEmailData
    },
  },

  methods: {
    nextButtonClick(e) {
      e.preventDefault()
      console.log(this.accountEmail)
      console.log(this.accountTeamId)
      this.$store.commit('numericTeamId', parseInt(this.accountTeamId))
      this.$store.dispatch('submitDashboardLoginEmail', this.accountEmail)
    }
  },

  mounted() {
    this.$store.commit('installProgress', 100)

  }
}
</script>